import { renderless, api } from "@opentiny/vue-renderless/dropdown-item/vue";
import { defineComponent, props, setup as _setup } from "@opentiny/vue-common";
import { iconYes } from "@opentiny/vue-icon";
import Popup from "@opentiny/vue-popup";
import Button from "@opentiny/vue-button";
import Clickoutside from "@opentiny/vue-renderless/common/deps/clickoutside";
import "@opentiny/vue-theme-mobile/dropdown-item/index.css";
function normalizeComponent(scriptExports, render, staticRenderFns, functionalTemplate, injectStyles, scopeId, moduleIdentifier, shadowMode) {
  var options = typeof scriptExports === "function" ? scriptExports.options : scriptExports;
  if (render) {
    options.render = render;
    options.staticRenderFns = staticRenderFns;
    options._compiled = true;
  }
  if (functionalTemplate) {
    options.functional = true;
  }
  if (scopeId) {
    options._scopeId = "data-v-" + scopeId;
  }
  var hook;
  if (moduleIdentifier) {
    hook = function hook2(context) {
      context = context || // cached call
      this.$vnode && this.$vnode.ssrContext || // stateful
      this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext;
      if (!context && typeof __VUE_SSR_CONTEXT__ !== "undefined") {
        context = __VUE_SSR_CONTEXT__;
      }
      if (injectStyles) {
        injectStyles.call(this, context);
      }
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier);
      }
    };
    options._ssrRegister = hook;
  } else if (injectStyles) {
    hook = shadowMode ? function() {
      injectStyles.call(this, (options.functional ? this.parent : this).$root.$options.shadowRoot);
    } : injectStyles;
  }
  if (hook) {
    if (options.functional) {
      options._injectStyles = hook;
      var originalRender = options.render;
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context);
        return originalRender(h, context);
      };
    } else {
      var existing = options.beforeCreate;
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook];
    }
  }
  return {
    exports: scriptExports,
    options
  };
}

var __vue2_script = defineComponent({
  directives: {
    Clickoutside
  },
  props: [].concat(props, ["modelValue", "title", "disabled", "titleClass", "options", "icon", "type"]),
  components: {
    IconYes: iconYes(),
    TinyPopup: Popup,
    TinyButton: Button
  },
  emits: ["update:modelValue", "open", "opened", "click", "change", "closed", "close", "reset", "confirm", "item-click"],
  setup: function setup(props2, context) {
    return _setup({
      props: props2,
      context,
      renderless,
      api
    });
  }
});
var render = function render2() {
  var _vm = this;
  var _h = _vm.$createElement;
  var _c = _vm._self._c || _h;
  return _c("div", {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.state.showWrapper,
      expression: "state.showWrapper"
    }],
    ref: "wrapper",
    staticClass: "tiny-mobile-dropdown-item",
    class: "tiny-mobile-dropdown-item--" + _vm.state.direction,
    style: _vm.state.itemStyle,
    on: {
      "click": _vm.clickWrapper
    }
  }, [_c("tiny-popup", {
    attrs: {
      "popup-class": "tiny-mobile-dropdown-item__content",
      "overlay": _vm.state.overlay,
      "close-on-click-overlay": _vm.state.closeOnClickOverlay,
      "closeable": false,
      "position": _vm.state.direction === "down" ? "top" : "bottom",
      "duration": _vm.state.transition ? _vm.state.duration : 0
    },
    on: {
      "open": _vm.open,
      "close": _vm.close,
      "opened": _vm.opened,
      "closed": _vm.closed
    },
    model: {
      value: _vm.state.showPopup,
      callback: function callback($$v) {
        _vm.$set(_vm.state, "showPopup", $$v);
      },
      expression: "state.showPopup"
    }
  }, [_vm._t("default", function() {
    return [_vm.type === "selection" ? _c("div", {
      staticClass: "tiny-mobile-dropdown-item__options"
    }, _vm._l(_vm.options, function(item, index) {
      return _c("div", {
        key: index,
        staticClass: "tiny-mobile-dropdown-item__cell tiny-mobile-dropdown-item__option",
        class: item.value === _vm.modelValue ? "is-active" : "",
        attrs: {
          "tabindex": "0"
        },
        on: {
          "click": function click($event) {
            return _vm.clickItem(item.value);
          }
        }
      }, [_c("div", {
        staticClass: "tiny-mobile-dropdown-item__option-icon"
      }, [_vm._t("icon", function() {
        return [_c(_vm.icon, {
          tag: "component"
        })];
      })], 2), _c("div", {
        staticClass: "tiny-mobile-dropdown-item__option-title"
      }, [_vm._t("title", function() {
        return [_c("span", {
          style: {
            color: item.value === _vm.modelValue && _vm.state.activeColor ? _vm.state.activeColor : ""
          }
        }, [_vm._v(_vm._s(item.text))])];
      }, {
        "titleData": item
      })], 2), _c("div", {
        staticClass: "tiny-mobile-dropdown-item__option-value"
      }, [item.value === _vm.modelValue ? _c("icon-yes", {
        attrs: {
          "fill": _vm.state.activeColor ? _vm.state.activeColor : "#f36f64"
        }
      }) : _vm._e()], 1)]);
    }), 0) : _vm._e(), _vm.type === "filter" ? _c("div", {
      directives: [{
        name: "clickoutside",
        rawName: "v-clickoutside",
        value: _vm.clickOutside,
        expression: "clickOutside"
      }],
      staticClass: "tiny-mobile-dropdown-item__filter"
    }, [_c("div", {
      staticClass: "tiny-mobile-dropdown-item__filter-wrap"
    }, _vm._l(_vm.options, function(item, key) {
      return _c("div", {
        key,
        staticClass: "tiny-mobile-dropdown-item__cell tiny-mobile-dropdown-item__filter-item"
      }, [_c("span", {
        staticClass: "tiny-mobile-dropdown-item__filter-title"
      }, [_vm._v(_vm._s(item.title))]), _c("ul", _vm._l(_vm.options.length === 0 ? item.data = [] : item.data, function(tag, tagkey) {
        return _c("li", {
          key: tagkey,
          staticClass: "tiny-mobile-dropdown-item__filter-li",
          class: [_vm.modelValue[key].indexOf(tag.value) > -1 ? "checked" : ""],
          style: _vm.getOptionStyle(tag, _vm.modelValue[key]),
          on: {
            "click": function click($event) {
              return _vm.tagClick(key, tag, $event);
            }
          }
        }, [_vm._v(" " + _vm._s(tag.text) + " ")]);
      }), 0)]);
    }), 0), _c("div", {
      staticClass: "tiny-mobile-dropdown-item__filter-operate"
    }, [_c("tiny-button", {
      on: {
        "click": _vm.reset
      }
    }, [_vm._v(" Reset ")]), _c("tiny-button", {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.confirm
      }
    }, [_vm._v(" OK ")])], 1)]) : _vm._e()];
  })], 2)], 1);
};
var staticRenderFns = [];
var __cssModules = {};
var __component__ = /* @__PURE__ */ normalizeComponent(__vue2_script, render, staticRenderFns, false, __vue2_injectStyles, null, null, null);
function __vue2_injectStyles(context) {
  for (var o in __cssModules) {
    this[o] = __cssModules[o];
  }
}
var mobile = /* @__PURE__ */ function() {
  return __component__.exports;
}();
export {
  mobile as default
};
